var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 72V30.75C18 27.1033 19.4487 23.6059 22.0273 21.0273C24.6059 18.4487 28.1033 17 31.75 17C35.3967 17 38.8941 18.4487 41.4727 21.0273C44.0513 23.6059 45.5 27.1033 45.5 30.75V72M18 51.375H45.5M73 17V72",
    stroke: "#008000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiColored);
export default __webpack_public_path__ + "static/media/ai-colored.ac6945c615009741ccb5bd0b1c7425d4.svg";
export { ForwardRef as ReactComponent };